// @ts-nocheck
import React from 'react';

interface ReactionDisplayProps {
    emoji: string;
    className?: string;
}

export const ReactionDisplay: React.FC<ReactionDisplayProps> = ({ emoji, className = '' }) => {
    if (emoji.startsWith('custom-img:')) {
        return <img src={emoji.replace('custom-img:', '')} className={`w-6 h-6 object-cover rounded-md ${className}`} alt="custom reaction" loading="lazy" />;
    }
    if (emoji.startsWith('custom-vid:')) {
        return <video src={emoji.replace('custom-vid:', '')} className={`w-6 h-6 object-cover rounded-md ${className}`} autoPlay loop muted playsInline />;
    }
    return <span className={`sticker-outline ${className}`}>{emoji}</span>;
};
